import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import LoginPage from "./component/LoginPage";
import ProtectedRoute from "./component/ProtectedRoute";
import AdminDashboard from "./component/AdminDashboard";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication status on initial load
  useEffect(() => {
    const storedAuthStatus = localStorage.getItem("authToken");
    if (storedAuthStatus) {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Redirect logic to keep authenticated users on admin page */}
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/admin" /> : <LoginPage setAuthenticated={setIsAuthenticated} />}
          />

          {/* Protected Route for Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch-All Route: Redirect unknown paths to login */}
          <Route path="*" element={<Navigate to={isAuthenticated ? "/admin" : "/"} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
